import { BaseRequest } from './BaseRequest';

export class TeamRequest extends BaseRequest {
    TeamName: string;
}